
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { ReminderColumnNames } from "@/utils/reminder-layouts/column-names";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			lang: "nl-be"
		};
	},
	props: {
		columnNames: {
			type: Object as () => ReminderColumnNames,
			required: true
		}
	},
	components: {
		AppCustomLanguageSelect
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
